var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yCode"},[_c('span',{on:{"click":_vm.send}},[_vm._v("发送验证码")])])}
var staticRenderFns = []

export { render, staticRenderFns }